module.exports = __webpack_public_path__ + "img/wujinmu3.f63262cc.jpg";